import React, { useRef, useState } from 'react';
import { Button, Collapse, Icon, Popover, Select } from 'antd';
import { v4 } from 'uuid';
import { CHART_TRANSLATION } from '../translationValues';
import { EditableCell } from './editableCell';

const { Panel } = Collapse;

export const panelStyle = {
  background: 'transparent',
  border: 0,
  borderRadius: '0px',
};

export const ChartCollapse = ({ children, defaultActiveKey }) => {
  return (
    <Collapse
      expandIconPosition="right"
      style={panelStyle}
      bordered={false}
      defaultActiveKey={defaultActiveKey}
    >
      {children}
    </Collapse>
  );
};

export const CollapsePanel = props => {
  return <Panel showArrow={false} {...props} />;
};

export const ChartSelect = ({ children, t, ...props }) => {
  return (
    <Select
      showArrow={false}
      placeholder={t(
        CHART_TRANSLATION.SELECT_A_VARIABLE.key,
        CHART_TRANSLATION.SELECT_A_VARIABLE.value,
      )}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) => {
        // Search through the option's text content
        const optionText = option?.props?.children?.toLowerCase() || '';
        const searchText = input.toLowerCase();
        return optionText.includes(searchText);
      }}
      {...props}
    >
      {children}
    </Select>
  );
};

export const OverlayHeader = ({ text, id, updateSource, deleteColumn }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const overlayContent = (
    <Button onClick={deleteColumn} style={{ padding: '0px 8px' }}>
      <Icon type="delete" />
    </Button>
  );
  return (
    <Popover
      trigger="click"
      visible={showOverlay}
      content={overlayContent}
      onVisibleChange={value => {
        setShowOverlay(value);
      }}
    >
      <div>
        <EditableCell text={text} id={id} updateSource={updateSource} />
      </div>
    </Popover>
  );
};

export const useCheckTableInFocus = () => {
  const tableRef = useRef();
  const tableKey = useRef(v4());
  const hasChildInFocus = () => {
    if (tableRef?.current?.contains(document.activeElement)) {
      return tableRef.current.contains(document.activeElement);
    }
    return false;
  };
  tableKey.current = hasChildInFocus() ? tableKey.current : v4();
  return [tableRef, tableKey.current];
};
